import React from "react";

const ProductCardSkeleton = () => {
    return (
        <div className="product-card skeleton">
            <div className="product-image skeleton-box"></div>

            <div className="product-card-lines w-100">
                <div className="skeleton-line short"></div>
                <div className="product-card-name skeleton-line"></div>
                <div className="product-card-detail pb-2 skeleton-line short"></div>
            </div>

            <div className="d-flex text-center w-100">
                <div className="btn-animate-enquiry me-1 w-100 fs-6 skeleton-btn"></div>
                <div className="btn-animate-addtocart w-100 fs-6 skeleton-btn"></div>
            </div>
        </div>
    );
};

export default ProductCardSkeleton;
